export interface LocalizationState {
  activeLang: string | null;
}

export const initialState: LocalizationState = {
  activeLang: null,
};
